<template>
  <div class="lang-select">
    <el-dropdown trigger="click" class="international" @command="handleSetTimeZone">
      <div>
        <svg-icon class-name="time-zone-icon" icon-class="time_zone" />
        <span class="lang-text">{{ timeZone }}:00</span>
        <i class="el-icon-caret-bottom icon-arrow-down" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <div class="time-zone-list">
          <el-dropdown-item v-for="(item,index) in timeZoneList" :key="index" :disabled="item === timeZone" :command="item">
            {{ item }}:00
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>

</template>

<script>
import { setTimeZone } from '@/api/components/components.js'

export default {
  data() {
    return {
      timeZoneList: [
        'UTC+1',
        'UTC+2',
        'UTC+3',
        'UTC+4',
        'UTC+5',
        'UTC+6',
        'UTC+7',
        'UTC+8',
        'UTC+9',
        'UTC+10',
        'UTC+11',
        'UTC+12',
        'UTC-12',
        'UTC-11',
        'UTC-10',
        'UTC-9',
        'UTC-8',
        'UTC-7',
        'UTC-6',
        'UTC-5',
        'UTC-4',
        'UTC-3',
        'UTC-2',
        'UTC-1'
      ]
    }
  },
  computed: {
    timeZone() {
      return this.$store.getters.timeZone
    }
  },
  created() {},
  methods: {
    handleSetTimeZone(timeZone) {
      const params = {
        country_code: this.$store.state.user.userInfo.country_code,
        timezone: timeZone
      }
      setTimeZone(params).then(res => {
        // 因切换了时区，需要更新请求头，所以要刷新页面
        location.reload()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.lang-select{
  position: relative;
  top: -4px;
}
.lang-text{
  margin: 0 8px;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 12px;
  color: #364250;
}

.icon-arrow-down{
  margin-left: 12px;;
  font-size: 12px;
  font-weight: bold;
}
.country-icon{
  font-size: 18px;
}
.time-zone-list{
  max-height: 289px;
  overflow-y: scroll;
}
/* 滚动条样式 */
.time-zone-list::-webkit-scrollbar {
    width: 4px; /*  设置纵轴（y轴）轴滚动条 */
}
/* 滚动条滑块（里面小方块） */
.time-zone-list::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #7A869E;
}
/* 滚动条轨道 */
.time-zone-list::-webkit-scrollbar-track {
    border-radius: 2px;
    background: #F6F6F6;
}
@media screen and (max-width: 761px) {
 .lang-text{
  display: none;
 }
}
</style>
